import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import {
  AppSiteCentralContainer,
  AppSiteSelectorContainer,
  BoxMenu,
  BoxMenuContainer,
  useClasses,
} from "./AppHeader.styles";
import { AppDrawer } from "./AppDrawer/AppDrawer";
import AppLogo from "./AppLogo/AppLogo";
import { AppSearch } from "./AppSearch/AppSearch";
import AppContext from "./AppContext/AppContext";
import { AppBrandMenu } from "./AppBrandMenu/AppBrandMenu";
import { AppBasketMenu } from "./AppBasketMenu/AppBasketMenu";
import { AppIconsOrderOffer } from "../../AppIcons";
import {
  AppProfile,
  AppSiteSelector,
} from "../../../configuration/componentsConfig";
import GoToPage from "../../GoToPage/GoToPage";
import useBrands from "../../../../explorer/hooks/useBrands";
import AppHeaderHelp from "./AppHeaderHelp/AppHeaderHelp";
import useCurrentSite from "../../../hook/useCurrentSite";

const AppHeader = () => {
  return <ResponsiveAppBar></ResponsiveAppBar>;
};

function ResponsiveAppBar() {
  const classes = useClasses();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const { currentBrand } = useBrands();
  const [currentSite] = useCurrentSite();

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const brandIsEnabled =
    currentBrand?.disabled === null ? true : !currentBrand?.disabled;
  const orderOfferHistoryEnabled =
    currentSite?.permissions?.canAccessOfferHistory === true ||
    currentSite?.permissions?.canAccessOrderHistory === true ||
    currentSite?.permissions?.canAccessServiceOrderHistory === true;

  return (
    <Box sx={{ flexGrow: 1 }} className="AppHeader">
      <AppBar sx={classes.appBar} className="AppHeader-app-bar">
        <Toolbar sx={classes.toolbar}>
          {/* <AppDrawerIcon handleDrawerToggle={handleDrawerToggle} /> */}
          <AppLogo />
          <AppContext />

          <AppSiteCentralContainer>
            {brandIsEnabled && (
              <>
                <AppSiteSelectorContainer className="osh-hint-site-selector">
                  <AppSiteSelector />
                </AppSiteSelectorContainer>

                <AppSearch />
              </>
            )}
          </AppSiteCentralContainer>

          <BoxMenuContainer className="osh-hint-mainbuttons">
            {brandIsEnabled && (
              <BoxMenu>
                <AppBasketMenu />
                <GoToPage 
                  disabled={!orderOfferHistoryEnabled} 
                  page="system.offerOrderHistory"
                >
                  <IconButton size="large" aria-label="Orders" color="inherit"
                    disabled={!orderOfferHistoryEnabled}>
                    <AppIconsOrderOffer />
                  </IconButton>
                </GoToPage> 
            </BoxMenu>
            )}
            <BoxMenu sx={{ display: { xs: "none", md: "flex" } }}>
              <AppProfile />
              <AppBrandMenu />
            </BoxMenu>
          </BoxMenuContainer>
        </Toolbar>
      </AppBar>
      <AppHeaderHelp />
      <nav>
        <AppDrawer open={mobileOpen} handleDrawerToggle={handleDrawerToggle} />
      </nav>
    </Box>
  );
}

export default AppHeader;
